import React, { Component } from 'react';
import { shape, string, number, bool } from 'prop-types';
import styles from './styles.scss';
import classnames from 'classnames';

export default class CreativeTableSummary extends Component {
  static propTypes = {
    summaryData: shape({
      title: string,
      ads: number,
      adVisit: number,
      adUser: number,
      visitOfAds: number,
      newAdUSer: number,
      newAdUsersPerAds: number,
    }).isRequired,
    isNewAdUsersSelected: bool,
  }

  render() {
    const { isNewAdUsersSelected } = this.props;
    const { title, ads, adVisit, visitOfAds, avgAdCost, newAdUsersPerAds, newAdUsers } = this.props.summaryData; //TODO: adUser
    const formattedTotalAdVisits = Math.round(adVisit);
    const formattedNewAdUsers = Math.round(newAdUsers);

    return(
      <div className={classnames(styles.tableRow, styles.summaryRow)}>
        <div data-test="summaryName" className={styles.tableCell}>{title}</div>
        <div className={styles.tableCell}/>
        <div className={styles.tableCell}/>
        {isNewAdUsersSelected 
          ? <div data-test="summaryNewAdUsers" className={styles.tableCell}>{formattedNewAdUsers.toLocaleString()}</div>
          : <div data-test="summaryAdVisits" className={styles.tableCell}>{formattedTotalAdVisits.toLocaleString()}</div>
        }
        {/* <div className={styles.tableCell}>{adUser.toLocaleString()}</div> */}
        <div data-test="summaryAds" className={styles.tableCell}>{ads.toLocaleString()}</div>
        {isNewAdUsersSelected 
          ? <div
              data-test="summaryNewAdUsersPerAds"
              className={classnames(styles.tableCell, styles.metricPerAdCell)}
            >
              {newAdUsersPerAds.toLocaleString()}
            </div>
          : <div data-test="summaryVisitsAds" className={classnames(styles.tableCell, styles.metricPerAdCell)}>{visitOfAds.toLocaleString()}</div>
        }
        {
          avgAdCost != null &&
          <div data-test="summaryAdCost" className={styles.tableCell}>{`$${avgAdCost.toFixed(2).toLocaleString()}`}</div>
        }
      </div>
    ) 
  }
}
